import { DateTime } from 'luxon';

/**
 * Removes offset from date time.
 * For example if provided date time is 2023-03-14T13:08:29+02:00,
 * the returned value is 2023-03-14T13:08:29+00:00
 *
 * @export
 * @param {DateTime} dateTime Input local date time.
 * @return {DateTime}  UTC date time.
 */
export function removeDateTimeLocalOffset(dateTime: DateTime): DateTime {
    return dateTime.toUTC().plus({ minutes: dateTime.offset });
}

/**
 * Changes offset from date time without changing time.
 * For example if provided date time is 2023-03-14T13:08:29+00:00,
 * with timezone, that gives offset of -05:00
 * the returned value is 2023-03-14T13:08:29-05:00
 *
 * @export
 * @param {DateTime} dateTime Input date time.
 * @param {string} timezone Input timezone.
 * @return {DateTime} Date time in specified time zone with offset applied.
 */
export function changeDateTimeTimeZoneOffset(dateTime: DateTime, timezone: string): DateTime {
    const localDateTime = dateTime.setZone(timezone);
    return localDateTime.minus({ minutes: localDateTime.offset });
}
